export const MUTE_STORAGE_KEY = "buffalo-bills-roulette:muted";

export const getStoredMutedState = () => {
    if (typeof window === "undefined") {
        return false;
    }

    return window.localStorage.getItem(MUTE_STORAGE_KEY) === "true";
};

export const setStoredMutedState = (muted: boolean) => {
    if (typeof window === "undefined") {
        return;
    }

    window.localStorage.setItem(MUTE_STORAGE_KEY, String(muted));
};
